import { render, staticRenderFns } from "./PlantVarietyForm.vue?vue&type=template&id=b61ed0d4&"
import script from "./PlantVarietyForm.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyForm.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyForm.vue?vue&type=style&index=0&id=b61ed0d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports